// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"3c625f7d","488":"881bef34"}[chunkId] + ".chunk.js";
};